import { ChangeEvent, ReactElement } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { colors } from '~/styles/colors';
import { CheckBox } from '../../ds';
import { FULL_DAY } from '../../schedules';
import { CheckIcon } from '../icons';
import { TimeInput24h } from './TimeInput24h';
import {
  InlineCheck, ModalError, ModalLabel, TimeField, TimeRow,
} from './styles';

interface TimeFieldControl {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}

interface TimeRangeFieldProps {
  id: string;
  label: string;
  field: TimeFieldControl;
  error?: string;
}

interface TimeRangeFieldsProps {
  start: TimeRangeFieldProps;
  end: TimeRangeFieldProps;
  fullDay: boolean;
  fullDayLabel: string;
  fullDayInput: UseFormRegisterReturn;
}

/**
 * Horário inicial, final e "dia inteiro" dos modais de programação e de exceção. Marcar o dia inteiro
 * preenche os campos com 00:00 e 23:59, para o horário exibido ser o que vai ser salvo.
 */
export function TimeRangeFields({
  start, end, fullDay, fullDayLabel, fullDayInput,
}: Readonly<TimeRangeFieldsProps>): ReactElement {
  function onFullDayChange(event: ChangeEvent<HTMLInputElement>): Promise<void | boolean> {
    if (event.target.checked) {
      start.field.onChange(FULL_DAY.start);
      end.field.onChange(FULL_DAY.end);
    }
    return fullDayInput.onChange(event);
  }

  return (
    <TimeRow>
      {[start, end].map(({
        id, label, field, error,
      }) => (
        <TimeField key={id}>
          <ModalLabel htmlFor={id}>{label}</ModalLabel>
          <TimeInput24h id={id} value={field.value} disabled={fullDay} onChange={field.onChange} onBlur={field.onBlur} />
          {error ? <ModalError>{error}</ModalError> : null}
        </TimeField>
      ))}
      <InlineCheck>
        <input type="checkbox" {...fullDayInput} onChange={onFullDayChange} />
        <CheckBox $checked={fullDay}><CheckIcon size={12} strokeWidth={3} color={colors.text['white-0']} /></CheckBox>
        {fullDayLabel}
      </InlineCheck>
    </TimeRow>
  );
}
